export enum PlanStep {
  evaluators = 1,
  objective = 2,
  synthesis = 3,
  strategy = 4,
  appraisal = 5,
  importSources = 6,
}

export enum ReviewStep {
  plan = 1,
  execute = 2,
  export = 3,
}
